import React, { useEffect, useState } from "react";
import axiosAuth from "../Axios/Interceptors";
import ServiceInfo from "./ServiceInfo";
import AppContext from "../Context/Context";

type QuoteInfoProps = {
  QuoteID: number;
  MNVQuoteID?: number;
};

const QuoteInfo: React.FC<QuoteInfoProps> = ({ QuoteID, MNVQuoteID = 0 }) => {
  const [AllLinkedQuotes, setAllLinkedQuotes] = useState<any[]>([]);
  const [JobRelatedData, setJobRelatedData] = useState<any>({
    Amounts: null,
  });

  useEffect(() => {
    if (QuoteID > 0 && MNVQuoteID == 0) {
      // LoadAllQuotesLinkedToThisJob(QuoteID);
    }
  }, [QuoteID, MNVQuoteID]);

  function LoadAllQuotesLinkedToThisJob(MNVJobID: number) {
    const data = { MNVQuoteID: MNVJobID };

    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuote/MNVQuoteGetDataSetByMNVJobIDCustom",
        {
          data,
        }
      )
      .then((res) => {
        const result = res.data.Data;
        
        if (MNVQuoteID === 0) {
          setAllLinkedQuotes(result[0] || []);

          if (result[1] && result[1][0]) {
            setJobRelatedData((prev: any) => ({
              ...prev,
              Amounts: result[1][0],
            }));
          }
        }
      })
      .catch((err) => console.error(err));
  }

  return (
    <div className="grid-d flex-gap10">
      {AllLinkedQuotes.length > 0 && (
        <>
          {AllLinkedQuotes.map((service, index) => (
            <ServiceInfo
              key={service.MNVQuoteID}
              quoteId={service.MNVQuoteID}
              totalServices={AllLinkedQuotes.length}
              serviceNumber={index + 1}
            />
          ))}
        </>
      )}
      {AllLinkedQuotes.length === 0 && (
        <ServiceInfo
          quoteId={QuoteID}
          totalServices={1}
          serviceNumber={1}
          isVanLevel={true}
        />
      )}
      {AllLinkedQuotes.length > 1 && JobRelatedData.Amounts && (
        <>
          <div className="flow-auto mt-25 auto-height">
            <table className="reuse-table">
              <tbody>
                <tr className="bold-font">
                  <td className="text-left" colSpan={2}>
                    Subtotal
                  </td>
                  <td className="text-right" colSpan={3}>
                    £
                    {(
                      JobRelatedData.Amounts.PayableAmount -
                      JobRelatedData.Amounts.Vat
                    )?.toLocaleString(
                      undefined,
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }
                    )}
                  </td>
                </tr>

                <tr className="bold-font">
                  <th className="text-left" colSpan={2}>
                    VAT
                  </th>
                  <th className="text-right" colSpan={3}>
                    £{JobRelatedData.Amounts.Vat?.toLocaleString(
                      undefined,
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }
                    )}
                  </th>
                </tr>

                <tr className="bold-font">
                  <th className="text-left" colSpan={2}>
                    Total Amount
                  </th>
                  <th className="text-right" colSpan={3}>
                    £{JobRelatedData.Amounts.PayableAmount?.toLocaleString(
                      undefined,
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }
                    )}
                  </th>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default QuoteInfo;
